import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BlockerComponent } from "../../shared/blocker/blocker.component";
import { SubRequiredComponent } from "../../shared/sub-required/sub-required.component";
import { SortPipe } from "../../shared/sort.pipe";
import { PlayerSortPipe } from "../../shared/player-sort.pipe";
import { PhotoPickerComponent } from "../../shared/photo-picker/photo-picker.component";
import { ImageCropperComponent } from "ngx-image-cropper";
import { LeagueListComponent } from "../../shared/league-list/league-list.component";
import { MemberAvatarComponent } from "../../shared/member-avatar/member-avatar.component";
import { SharedModule } from "../shared/shared.module";

import { ProfileComponent } from "../../profile/profile.component";
import { RouterModule } from "@angular/router";
import { ObjArrPipe } from "../../shared/obj-arr.pipe";
import { SearchPipe } from "../../shared/search.pipe";
import { ClubComponent } from "../../club/club.component";
import { JoinClubComponent } from "../../lobby/join-club/join-club.component";
import { DesignSystemModule } from "../../design-system/design-system.module";

@NgModule({
    imports: [
    CommonModule,
    ImageCropperComponent,
    SharedModule,
    RouterModule,
    DesignSystemModule,
    BlockerComponent,
    SubRequiredComponent,
    PhotoPickerComponent,
    LeagueListComponent,
    MemberAvatarComponent,
    ProfileComponent,
    SortPipe,
    PlayerSortPipe,
    ObjArrPipe,
    SearchPipe,
    ClubComponent,
    JoinClubComponent,
],
    exports: [
        BlockerComponent,
        SubRequiredComponent,
        PhotoPickerComponent,
        SortPipe,
        PlayerSortPipe,
        LeagueListComponent,
        MemberAvatarComponent,
        ProfileComponent,
        ImageCropperComponent,
        ObjArrPipe,
        SearchPipe,
        ClubComponent,
        JoinClubComponent,
    ]
})
export class ClubSharedModule {}
